module.exports = __webpack_public_path__ + "img/logo-alvaro-herrero.1cdbb622.svg";